export type LeaveCampaignSubmission = {
  admin_approval?: string | null;
  disqualified?: boolean | null;
};

/**
 * What leaving a campaign does to the viewer's clips, for the confirmation
 * dialog. Mirrors the backend's planLeaveCampaign: pending (neutral, not
 * disqualified) clips are rejected; approved, non-disqualified clips keep
 * their payout and keep earning.
 */
export function summarizeLeaveCampaign(
  submissions: LeaveCampaignSubmission[],
): { pendingCount: number; approvedCount: number } {
  let pendingCount = 0;
  let approvedCount = 0;
  for (const s of submissions) {
    if (s.disqualified) continue;
    const approval = s.admin_approval || 'neutral';
    if (approval === 'neutral') pendingCount += 1;
    else if (approval === 'approved') approvedCount += 1;
  }
  return { pendingCount, approvedCount };
}
